import type { SiteConfig } from '@/types'

import { BUSINESS, SITE_URL } from '@/content/business'

export const siteConfig: SiteConfig = {
    name: BUSINESS.name,
    description: "Family-owned exterior contractor in Madison, Alabama. Exterior window replacement, exterior doors, siding, roofing and pressure and soft washing across Huntsville and North Alabama. Free written estimates.",
    placeholder: '',
    url: SITE_URL,
    ogImage: '/images/acm/na.webp',
    links: {}
}
